module.exports = __webpack_public_path__ + "img/5_19.248fd67f.png";